import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import './ResponsiveBlocklyGameLayout.css';

interface ResponsiveBlocklyGameLayoutProps {
    blocklyComponent: React.ReactNode;
    gameComponent: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

const ResponsiveBlocklyGameLayout: React.FC<ResponsiveBlocklyGameLayoutProps> = ({
    blocklyComponent,
    gameComponent,
    className,
    style
}) => {
    const [isMobile, setIsMobile] = useState(false);
    const [isTablet, setIsTablet] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width < 768);
            setIsTablet(width >= 768 && width < 1024);
        };

        // Check on mount
        checkScreenSize();

        // Add event listener for window resize
        window.addEventListener('resize', checkScreenSize);

        // Cleanup
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // Mobile and tablet: Stack vertically (Blockly on top, Game below)
    if (isMobile || isTablet) {
        return (
            <div 
                className={`responsive-blockly-game-container ${className || ''}`} 
                style={{ ...style, height: '100%' }}
            >
                {/* Blockly Section - Top */}
                <div className="responsive-blockly-section blockly">
                    {blocklyComponent}
                </div>
                
                {/* Game Section - Bottom */}
                <div className="responsive-blockly-section game">
                    <div className="game-wrapper">
                        {gameComponent}
                    </div>
                </div>
            </div>
        );
    }

    // Desktop: Side by side layout (like IDEPhaser)
    return (
        <div 
            className={`responsive-blockly-game-container desktop ${className || ''}`} 
            style={{ height: '100%', ...style }}
        >
            <Row gutter={16} style={{ height: '100%', width: '100%' }}>
                <Col span={12} style={{ height: '100%' }}>
                    <div className="responsive-blockly-section blockly">
                        {blocklyComponent}
                    </div>
                </Col>
                <Col span={12} style={{ height: '100%' }}>
                    <div className="responsive-blockly-section game">
                        <div className="game-wrapper">
                            {gameComponent}
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default ResponsiveBlocklyGameLayout;
